import { FC, useState } from 'react'
import { IonButton, IonIcon } from '@ionic/react'
import { add } from 'ionicons/icons'
import ScriptReceiverModalForm from './ScriptReceiverModalForm'

interface OwnProps {
  text?: string
  onAddSuccess: (event: any) => void
}
interface ScriptReceiverAddButtonProps extends OwnProps {}
const ScriptReceiverAddButton: FC<ScriptReceiverAddButtonProps> = ({ text, onAddSuccess }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <IonButton onClick={() => setShowModal(true)}>
        {text}
        <IonIcon icon={add} slot={!!text ? 'start' : 'icon-only'} />
      </IonButton>
      <ScriptReceiverModalForm
        isOpen={showModal}
        onDidDismiss={(e) => {
          setShowModal(false)
          onAddSuccess(e?.detail?.data)
        }}
      />
    </>
  )
}

export default ScriptReceiverAddButton
